import fetchServer from "../helpers/api/fetchServer";

export const createCampaign = async ({
  advertiserId,
  hasNoBrand,
  brandId,
  name,
  startDate,
  endDate,
  timezone,
  targetGender,
  targetAgeMinimum,
  targetAgeMaximum,
  targetOther,
  defaultMarginRate,
}) => {
  const method = "POST";
  const urlAPI = "/api/campaigns";
  const body = {
    advertiser: advertiserId,
    hasNoBrand,
    ...(hasNoBrand ? {} : { brand: brandId }),
    name,
    startDate,
    endDate,
    timezone,
    targetGender,
    targetAgeMinimum,
    targetAgeMaximum,
    targetOther,
    defaultMarginRate,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const getCampaigns = async () => {
  const method = "GET";
  const urlAPI = "/api/campaigns";
  return await fetchServer({ method, urlAPI });
};

export const getCampaignsByAdvertiser = async (advertiserId) => {
  const method = "GET";
  const urlAPI = `/api/campaigns?advertiser=${advertiserId}`;
  return await fetchServer({ method, urlAPI });
};

export const getCampaignsByBrand = async (brandId) => {
  const method = "GET";
  const urlAPI = `/api/campaigns?brand=${brandId}`;
  return await fetchServer({ method, urlAPI });
};

export const getCampaign = async (id) => {
  const method = "GET";
  const urlAPI = `/api/campaigns/${id}`;
  return await fetchServer({ method, urlAPI, source: "CAMPAIGN" });
};

export const updateCampaign = async ({
  id,
  advertiserId,
  hasNoBrand,
  brandId,
  name,
  startDate,
  endDate,
  timezone,
  targetGender,
  targetAgeMinimum,
  targetAgeMaximum,
  targetOther,
  defaultMarginRate,
  hasNoProposal,
  proposalUrl,
  proposalLanguageId,
  isProposalSent,
  alternativeProposalUrl,
  alternativeProposalLanguageId,
  isProposalClientValidated,
  hasNoEndReport,
  endReportUrl,
  endReportLanguageId,
  isEndReportSent,
  alternativeEndReportUrl,
  alternativeEndReportLanguageId,
  invoiceCode,
  isInvoiceSent,
}) => {
  const method = "PATCH";
  const urlAPI = `/api/campaigns/${id}`;
  const body = {
    advertiser: advertiserId,
    hasNoBrand,
    ...(hasNoBrand ? {} : { brand: brandId }),
    name,
    startDate,
    endDate,
    timezone,
    targetGender,
    targetAgeMinimum,
    targetAgeMaximum,
    targetOther,
    defaultMarginRate,
    hasNoProposal,
    ...(proposalUrl ? { proposalUrl} : {}),
    ...(proposalLanguageId ? { proposalLanguage: proposalLanguageId } : {}),
    isProposalSent,
    ...(alternativeProposalUrl ? { alternativeProposalUrl} : {}),
    ...(alternativeProposalLanguageId ? { alternativeProposalLanguage: alternativeProposalLanguageId } : {}),
    isProposalClientValidated,
    hasNoEndReport,
    ...(endReportUrl ? { endReportUrl} : {}),
    ...(endReportLanguageId ? { endReportLanguage: endReportLanguageId } : {}),
    isEndReportSent,
    ...(alternativeEndReportUrl ? { alternativeEndReportUrl} : {}),
    ...(alternativeEndReportLanguageId ? { alternativeEndReportLanguage: alternativeEndReportLanguageId } : {}),
    invoiceCode,
    isInvoiceSent,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const updateCampaignGeneral = async ({
  id,
  advertiserId,
  hasNoBrand,
  brandId,
  name,
  startDate,
  endDate,
  timezone,
  defaultMarginRate,
}) => {
  const method = "PATCH";
  const urlAPI = `/api/campaigns/${id}`;
  const body = {
    advertiser: advertiserId,
    hasNoBrand,
    ...(hasNoBrand ? {} : { brand: brandId }),
    name,
    startDate,
    endDate,
    timezone,
    defaultMarginRate,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const updateCampaignTarget = async ({
  id,
  targetGender,
  targetAgeMinimum,
  targetAgeMaximum,
  targetOther,
}) => {
  const method = "PATCH";
  const urlAPI = `/api/campaigns/${id}`;
  const body = {
    targetGender,
    targetAgeMinimum,
    targetAgeMaximum,
    targetOther,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const updateCampaignProposal = async ({
  id,
  hasNoProposal,
  proposalUrl,
  proposalLanguageId,
  isProposalSent,
  alternativeProposalUrl,
  alternativeProposalLanguageId,
  isProposalClientValidated,
}) => {
  const method = "PATCH";
  const urlAPI = `/api/campaigns/${id}`;
  const body = {
    hasNoProposal,
    ...(proposalUrl ? { proposalUrl} : {}),
    ...(proposalLanguageId ? { proposalLanguage: proposalLanguageId } : {}),
    isProposalSent,
    ...(alternativeProposalUrl ? { alternativeProposalUrl} : {}),
    ...(alternativeProposalLanguageId ? { alternativeProposalLanguage: alternativeProposalLanguageId } : {}),
    isProposalClientValidated,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const updateCampaignEndReport = async ({
  id,
  hasNoEndReport,
  endReportUrl,
  endReportLanguageId,
  isEndReportSent,
  alternativeEndReportUrl,
  alternativeEndReportLanguageId,
}) => {
  const method = "PATCH";
  const urlAPI = `/api/campaigns/${id}`;
  const body = {
    hasNoEndReport,
    ...(endReportUrl ? { endReportUrl} : {}),
    ...(endReportLanguageId ? { endReportLanguage: endReportLanguageId } : {}),
    isEndReportSent,
    ...(alternativeEndReportUrl ? { alternativeEndReportUrl} : {}),
    ...(alternativeEndReportLanguageId ? { alternativeEndReportLanguage: alternativeEndReportLanguageId } : {}),
  };
  return await fetchServer({ method, urlAPI, body });
};

export const updateCampaignInvoice = async ({
  id,
  invoiceCode,
  isInvoiceSent,
}) => {
  const method = "PATCH";
  const urlAPI = `/api/campaigns/${id}`;
  const body = {
    invoiceCode,
    isInvoiceSent,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const updateCampaignSetup = async ({
  id,
  isAdOpsSetupDone,
  adOpsSetupComment,
}) => {
  const method = "PATCH";
  const urlAPI = `/api/campaigns/${id}`;
  const body = {
    isAdOpsSetupDone,
    adOpsSetupComment,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const updateCampaignLiveCheck = async ({ id, isLiveChecked }) => {
  const method = "PATCH";
  const urlAPI = `/api/campaigns/${id}`;
  const body = {
    isLiveChecked,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const updateCampaignEmailStart = async ({
  id,
  isStartCampaignEmailSent,
}) => {
  const method = "PATCH";
  const urlAPI = `/api/campaigns/${id}`;
  const body = {
    isStartCampaignEmailSent,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const updateCampaignEmailEnd = async ({
  id,
  isEndCampaignEmailSent,
}) => {
  const method = "PATCH";
  const urlAPI = `/api/campaigns/${id}`;
  const body = {
    isEndCampaignEmailSent,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const updateCampaignTargetingCheck = async ({
  id,
  isTargetingCheckDone,
  targetingCheckComment,
}) => {
  const method = "PATCH";
  const urlAPI = `/api/campaigns/${id}`;
  const body = {
    isTargetingCheckDone,
    targetingCheckComment,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const updateCampaignConfigTPCReporting = async ({
  id,
  isConfigTPCReportingDone,
  configTPCReportingComment,
}) => {
  const method = "PATCH";
  const urlAPI = `/api/campaigns/${id}`;
  const body = {
    isConfigTPCReportingDone,
    configTPCReportingComment,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const updateCampaignGoalCheckStart = async ({
  id,
  isGoalCheckStartDone,
  goalCheckStartComment,
}) => {
  const method = "PATCH";
  const urlAPI = `/api/campaigns/${id}`;
  const body = {
    isGoalCheckStartDone,
    goalCheckStartComment,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const updateCampaignGoalCheckMid = async ({
  id,
  isGoalCheckMidDone,
  goalCheckMidComment,
}) => {
  const method = "PATCH";
  const urlAPI = `/api/campaigns/${id}`;
  const body = {
    isGoalCheckMidDone,
    goalCheckMidComment,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const updateCampaignFinalizeMargin = async ({
  id,
  isMarginFinalized,
}) => {
  const method = "PATCH";
  const urlAPI = `/api/campaigns/${id}`;
  const body = {
    isMarginFinalized,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const deleteCampaign = async (id) => {
  const method = "DELETE";
  const urlAPI = `/api/campaigns/${id}`;
  return await fetchServer({ method, urlAPI });
};

export const restoreCampaign = async (id) => {
  const method = "POST";
  const urlAPI = `/api/campaigns/${id}/restore`;
  return await fetchServer({ method, urlAPI });
};

export const deleteCampaigns = async (ids) => {
  const method = "POST";
  const urlAPI = "/api/campaigns/delete-many";
  const body = {ids};
  return await fetchServer({ method, urlAPI, body });
};

export const restoreCampaigns = async (ids) => {
  const method = "POST";
  const urlAPI = "/api/campaigns/restore-many";
  const body = {ids};
  return await fetchServer({ method, urlAPI, body });
};
